export const mappingCountries: { [key: string]: string } = {
  US: "United States",
  DE: "Germany",
  UK: "United Kingdom",
  JP: "Japan",
  CA: "Canada",
  FR: "France",
  KR: "South Korea",
  AU: "Australia",
  BR: "Brazil",
  IT: "Italy",
  ES: "Spain",
  NL: "Netherlands",
  SE: "Sweden",
  CH: "Switzerland",
  SA: "Saudi Arabia",
  AE: "United Arab Emirates",
  SG: "Singapore",
  NO: "Norway",
  DK: "Denmark",
  FI: "Finland",
  AT: "Austria",
  NZ: "New Zealand",
  PL: "Poland",
  BE: "Belgium",
  IE: "Ireland",
};
